import Projects from './Projects/Projects';

export const pages = [
  {
    id: 0,
    name: 'PROJECTS',
    Component: Projects
  }
];
